import { Alert, Button, Card, Col, Form, Input, Modal, Row } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import registerService from "../../services/registerService";
import "./RegisterForm.css";
import { AgencyRegister, createAgentDef } from "../../types/registerTypes";
import MainLanding from "../../img/main-landing.png";
import TermsAndConditions from "./TermsAndConditions";

const RegisterForm = () => {
  const history = useHistory();
  const [visible, setVisible] = useState<boolean>(false);
  const [agent, setAgent] = useState<AgencyRegister>(createAgentDef());
  const [registerFailed, setRegisterFailed] = useState<boolean>(false);
  const [apiCallInProgess, setApiCallInProgress] = useState<boolean>(false);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    setRegisterFailed(false);
    setApiCallInProgress(true);
    const registerResult = await registerService.Register(agent);
    // show that u can check .length if youre not sure what does the empty array means
    // is null or empty on array equivalent
    setApiCallInProgress(false);
    const registerSuccess = registerResult.status === 200;

    if (!registerSuccess && registerResult.statusText?.length > 0) {
      setRegisterFailed(true);
      return;
    }

    if (registerSuccess) {
      setRegisterFailed(false);
      history.push("/registerconfirm");
    } else {
      setRegisterFailed(true);
    }
  };

  return (
    <>
      <div className="landing-page">
        <img src={MainLanding} className="page-image" alt="" />
      </div>
      <div className="register-page-card page-card">
        <Card className="page-card-element">
          <h1 className="login-card-title">Register</h1>
          <Form
            name="basic"
            className="register-form"
            onChange={(e) => setRegisterFailed(false)}
            onFinish={(e) => handleSubmit(e)}
            layout="vertical"
          >
            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Company name:"
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: "Please provide your Company name!",
                    },
                  ]}
                >
                  <Input
                    value={agent?.CompanyName}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CompanyName")
                    }
                  />
                </Form.Item>
              </Col>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="City:"
                  name="companyCity"
                >
                  <Input
                    value={agent?.CompanyCity}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CompanyCity")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Address"
                  name="companyAddress"
                >
                  <Input
                    value={agent?.CompanyAddress}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CompanyAddress")
                    }
                  />
                </Form.Item>
              </Col>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                {" "}
                <Form.Item
                  className="register-card-form-item"
                  label="Postal code"
                  name="companyPostal"
                >
                  <Input
                    value={agent?.CompanyPostal}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CompanyPostal")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <h3 className="register-h3">Company Contact</h3>

            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="First name"
                  name="agentForename"
                  rules={[
                    {
                      required: true,
                      message: "Please provide your First name!",
                    },
                  ]}
                >
                  <Input
                    value={agent?.AgentForename}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "AgentForename")
                    }
                  />
                </Form.Item>
              </Col>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Last name"
                  name="agentSurname"
                  rules={[
                    {
                      required: true,
                      message: "Please provide your Last name!",
                    },
                  ]}
                >
                  <Input
                    value={agent?.AgentSurname}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "AgentSurname")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Email"
                  name="agentEmail"
                  rules={[
                    {
                      required: true,
                      message: "Please provide your Email!",
                    },
                  ]}
                >
                  <Input
                    value={agent?.AgentEmail}
                    onChange={(e) => onTodoChange(e.target.value, "AgentEmail")}
                  />
                </Form.Item>
              </Col>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Phone"
                  name="agentPhone"
                >
                  <Input
                    value={agent?.AgentPhone}
                    onChange={(e) => onTodoChange(e.target.value, "AgentPhone")}
                  />
                </Form.Item>
              </Col>
            </Row>

            <h3 className="register-h3">Cruise Line Contact</h3>

            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="First name"
                  name="cruiselineForename"
                >
                  <Input
                    value={agent?.CruiselineForename}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CruiselineForename")
                    }
                  />
                </Form.Item>
              </Col>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                <Form.Item
                  className="register-card-form-item"
                  label="Last name"
                  name="cruiselineSurname"
                >
                  <Input
                    value={agent?.CruiselineSurname}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CruiselineSurname")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col
                className="register-item"
                xs={24}
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
              >
                {" "}
                <Form.Item
                  className="register-card-form-item"
                  label="Email"
                  name="cruiselineEmail"
                >
                  <Input
                    value={agent?.CruiselineEmail}
                    onChange={(e) =>
                      onTodoChange(e.target.value, "CruiselineEmail")
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item className="form-validation">
              {registerFailed ? (
                <Alert message="Register Failed!" type="error" />
              ) : null}
            </Form.Item>

            <div className="register-terms-conditions">
              <span>
                By proceeding, I agree to Visitors handling Terms and Conditions{" "}
                <Button
                  className="page-card-link"
                  type="link"
                  onClick={showModal}
                >
                  Terms of Use
                </Button>{" "}
                and acknowledge that I have read them.
              </span>
            </div>
            <div className="register-card-form-item-login">
              Already have an account?{" "}
              <Button
                className="page-card-link"
                type="link"
                onClick={() => history.push("/login")}
              >
                Sign in
              </Button>
            </div>

            <Form.Item className="form-validation register-card-form-button">
              <Button
                type="primary"
                className="page-card-button page-card-button"
                htmlType="submit"
                loading={apiCallInProgess}
              >
                {apiCallInProgess ? "" : "Create account"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
      <Modal
        visible={visible}
        title="Please read these terms carefully"
        width={1000}
        closable={false}
        footer={[
          <div style={{ textAlign: "center" }}>
            <Button key="back" type="primary" onClick={hideModal}>
              OK
            </Button>
          </div>,
        ]}
      >
        <TermsAndConditions />
      </Modal>
    </>
  );

  function onTodoChange(value: string, key: string): void {
    setAgent((agent) => ({
      ...agent,
      [key]: value,
    }));
  }
};

RegisterForm.displayName = "Register Form";

export default RegisterForm;
